import { ErrorWithFields as e } from "./error-with-fields.mjs";
//#region src/errors/too-many-requests.ts
var t = class extends e {};
//#endregion
export { t as TooManyRequests };
